<div class="container p-0">
	<div
		class="header-step-wrapper p-0 d-flex flex-column justify-content-center align-items-center">
		<div class="col-auto p-0 image_wrapper-overlay">
			<img
				class="img-header-overlay"
				loading="lazy"
				[src]="image"
				[style.object-position]="pr" />
			<div class="overlay"></div>
			<div class="image-vector-3"></div>
			<div class="image-vector-2"></div>
			<div class="image-vector-1"></div>
		</div>
	</div>
</div>
